class PredictiveSearch extends window.BAO.CustomElement() {
  static get requiredElements () {
    return [
      'input',
    ]
  }

  constructor () {
    super()

    this.minSearchLength = 2

    this.onInputChange = window.BAO.Utils.debounce(this.onInputChange.bind(this), 500)
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.els.input.element, 'input', this.onInputChange)
  }

  async onInputChange () {
    this.searchTerm = this.els.input.element.value.trim()

    if (!this.searchTerm || this.searchTerm.length < this.minSearchLength) {
      this.showResults(false)
      return
    }

    try {
      await this.getSearchResults(this.searchTerm)
      this.showResults(true)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Search failed:', error)
      this.showResults(false)
    }
  }

  async getSearchResults () {
    try {
      // eslint-disable-next-line compat/compat
      const response = await fetch(`/search/suggest?q=${this.searchTerm}&resources[type]=product,collection&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,body&section_id=predictive-search`)
      const text = await response.text()

      const html = document.createElement('div')
      html.innerHTML = text

      const countResponse = await fetch(`/search?q=${this.searchTerm}&type=product&section_id=predictive-search-results-count`)
      const countText = await countResponse.text().then(text => text.trim())

      let countElement = ''

      if (
        countText.includes(
          'data-predictive-search-external-el="totalProductCount"',
        )
      ) {
        const countHtml = document.createElement('div')
        countHtml.innerHTML = countText

        countElement = countHtml
          .querySelector('#search-results-count')
          .innerHTML.trim()
      }

      const productResults = html.querySelector('#predictive-search-products')
      const collectionResults = html.querySelector('#predictive-search-collections')

      this.handleProductResults(productResults, countElement)
      this.handleCollectionResults(collectionResults)
    } catch (e) {
      console.error(e)
    }
  }

  showResults (state) {
    this.externalEls['products-panel'].element.setAttribute(
      'aria-hidden',
      state === false,
    )
    this.externalEls['default-content'].element.setAttribute(
      'aria-hidden',
      state === true,
    )

    this.externalEls['collections-desktop'].element.setAttribute('aria-hidden', state === false)
    this.externalEls['collections-mobile'].element.setAttribute('aria-hidden', state === false)
    this.externalEls['default-pages'].element.setAttribute('aria-hidden', state === true)

    // Delay the event emission to allow for DOM rendering
    setTimeout(() => {
      window.BAO.dispatchEvent(
        window.BAO.EVENTS.SEARCH_TAB.SEARCH_RESULTS_LOADED,
      )
    }, 0)
  }

  handleProductResults (results, count) {
    if (results) {
      this.externalEls['products-grid'].element.innerHTML = results.innerHTML

      if (count) {
        this.externalEls['products-results-count'].element.innerHTML = count
        this.externalEls['products-link'].element.setAttribute('href', `/search?q=${this.searchTerm}&type=product`)
      } else {
        this.externalEls['products-results-count'].element.innerHTML = ''
        this.externalEls['products-link'].element.setAttribute('href', '/search')
      }
    }
  }

  handleCollectionResults (results) {
    if (results && results.dataset.resultCount > 0) {
      this.externalEls['collections-desktop'].element.innerHTML = results.innerHTML
      this.externalEls['collections-mobile'].element.innerHTML = results.innerHTML

      this.externalEls['collections-desktop'].element.setAttribute('aria-hidden', results.dataset.resultCount === '0')
      this.externalEls['collections-mobile'].element.setAttribute('aria-hidden', results.dataset.resultCount === '0')
      this.externalEls['default-pages'].element.setAttribute('aria-hidden', true)
    } else {
      this.externalEls['collections-desktop'].element.setAttribute('aria-hidden', true)
      this.externalEls['collections-mobile'].element.setAttribute('aria-hidden', true)
      this.externalEls['default-pages'].element.setAttribute('aria-hidden', false)
    }
  }
}

customElements.define('predictive-search', PredictiveSearch)
